module.exports = __webpack_public_path__ + "img/04@2x.c29481fc.png";